var map = {
	"./bg-1.svg": 3892,
	"./bg-2.svg": 8487,
	"./bg-3.svg": 5686,
	"./bg-4.svg": 8921,
	"./carb.svg": 2071,
	"./clip.svg": 7077,
	"./close.svg": 7733,
	"./exit.svg": 7139,
	"./hum.svg": 5591,
	"./key.svg": 1120,
	"./list.svg": 7743,
	"./logo.svg": 3914,
	"./logotype.svg": 9674,
	"./mir.svg": 5237,
	"./preloader.svg": 7151,
	"./profile.svg": 2198,
	"./reports.svg": 2476,
	"./send.svg": 4505,
	"./share.svg": 6060,
	"./temp.svg": 4049,
	"./view.svg": 8868,
	"./visa.svg": 8932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;